import React from 'react';
import { node, oneOf, string } from 'prop-types';
import classNames from 'classnames';
import css from './IconButton.module.css';

/**
 * A button that shows only an icon: round and borderless on public pages (40px), square and
 * outlined on the dashboard (36px). `label` names it for screen readers and shows as a tooltip,
 * so pass the translated action ("Save", "Close").
 */
const IconButton = props => {
  const { rootClassName, className, label, tone, children, ...rest } = props;
  const classes = classNames(rootClassName || css.root, css[tone], className);
  return (
    <button type="button" className={classes} aria-label={label} title={label} {...rest}>
      {children}
    </button>
  );
};

IconButton.defaultProps = {
  rootClassName: null,
  className: null,
  tone: 'default',
};

IconButton.propTypes = {
  rootClassName: string,
  className: string,
  label: string.isRequired,
  tone: oneOf(['default', 'dark', 'danger']),
  children: node.isRequired,
};

export default IconButton;
